export const FLAG_BUS_ASSIGNMENT_SCHEDULES = 'FLAG_BUS_ASSIGNMENT_SCHEDULES';
export const GET_BUS_ASSIGNMENT_SCHEDULES = 'GET_BUS_ASSIGNMENT_SCHEDULES';
export const CLEAR_BUS_ASSIGNMENT_SCHEDULES = 'CLEAR_BUS_ASSIGNMENT_SCHEDULES';
export const FLAG_BUS_ASSIGNMENT_SCHEDULE_ACTIVITY =
  'FLAG_BUS_ASSIGNMENT_SCHEDULE_ACTIVITY';
export const GET_BUS_ASSIGNMENT_SCHEDULE = 'GET_BUS_ASSIGNMENT_SCHEDULE';
export const CLEAR_BUS_ASSIGNMENT_SCHEDULE = 'CLEAR_BUS_ASSIGNMENT_SCHEDULE';
